import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { signOut } from '../../store/AdminSlices/adminUserSlice';

interface NavItem {
  label: string;
  path: string;
  match: string[];
  icon: React.ReactElement;
}

interface SupportNavItem {
  label: string;
  path?: string;
  tab?: string;
  action?: string;
  icon: React.ReactElement;
}

const mainNav: NavItem[] = [
  {
    label: 'Home',
    path: '/',
    match: ['/', '/home'],
    icon: (
      <svg
        className="sidebar-item-icon"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.69z" />
        <path d="M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198a2.29 2.29 0 00.091-.086L12 5.43z" />
      </svg>
    ),
  },
  {
    label: 'Coaches',
    path: '/coaches',
    match: ['/coaches'],
    icon: (
      <svg
        className="sidebar-item-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        <path d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    label: 'Students',
    path: '/students',
    match: ['/students'],
    icon: (
      <svg
        className="sidebar-item-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        <path d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    label: 'Student Requests',
    path: '/requests',
    match: ['/requests'],
    icon: (
      <svg
        className="sidebar-item-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        <path d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    label: 'Sessions',
    path: '/sessions',
    match: ['/sessions'],
    icon: (
      <svg
        className="sidebar-item-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        <path d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    label: 'Reviews & Feedback',
    path: '/reviews',
    match: ['/reviews'],
    icon: (
      <svg
        className="sidebar-item-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        <path d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    label: 'Reports & Concerns',
    path: '/reports',
    match: ['/reports'],
    icon: (
      <svg
        className="sidebar-item-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        <path d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    label: 'Messages',
    path: '/messages',
    match: ['/messages'],
    icon: (
      <svg
        className="sidebar-item-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        <path d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 01-.825-.242m9.345-8.334a2.126 2.126 0 00-.476-.095 48.64 48.64 0 00-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0011.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    label: 'Payouts',
    path: '/payouts',
    match: ['/payouts'],
    icon: (
      <svg
        className="sidebar-item-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        <path d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
];

const supportNav: SupportNavItem[] = [
  {
    label: 'Settings',
    path: '/settings',
    icon: (
      <svg
        className="sidebar-item-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        <path d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    label: 'Sign Out',
    action: 'signout',
    icon: (
      <svg
        className="sidebar-item-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <polyline points="16 17 21 12 16 7" />
        <line x1="21" y1="12" x2="9" y2="12" />
      </svg>
    ),
  },
];

const Sidebar: React.FC = () => {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isAccountOpen, setIsAccountOpen] = useState(false);
  const { currentUser, loading } = useAppSelector((state) => state.adminUser);

  const handleSignOut = async () => {
    try {
      await dispatch(signOut()).unwrap();
    } finally {
      window.location.href = process.env.REACT_APP_AUTH_REDIRECT || 'https://guiding-hedgehog-41.accounts.dev/sign-in';
    }
  };

  const displayName = currentUser?.name || currentUser?.email || 'Loading...';
  
  const displayRole = currentUser?.role 
    ? currentUser.role.charAt(0).toUpperCase() + currentUser.role.slice(1)
    : 'Administrator';

  const initials = currentUser?.name
    ? currentUser.name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
    : currentUser?.email?.[0]?.toUpperCase() || 'A';

  const isItemActive = (match: string[]) =>
    match.some((path) =>
      path === '/' ? pathname === '/' : pathname.startsWith(path)
    );

  return (
    <aside className={`sidebar ${isCollapsed ? 'sidebar--collapsed' : ''}`}>
      <div className="sidebar-header">
        <h1 className="sidebar-brand">Admin</h1>

        <button
          className="sidebar-collapse-btn"
          type="button"
          aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          onClick={() => setIsCollapsed((prev) => !prev)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            aria-hidden="true"
          >
            <g clipPath="url(#clip0_161_18073)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.8333 2.5C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H15.8333ZM6.66667 4.16667H4.16667V15.8333H6.66667V4.16667ZM15.8333 4.16667H8.33333V15.8333H15.8333V4.16667ZM12.3275 7.64333C12.4775 7.49388 12.6787 7.4071 12.8903 7.40064C13.1019 7.39418 13.3081 7.46851 13.4669 7.60854C13.6257 7.74857 13.7253 7.94379 13.7453 8.15456C13.7654 8.36533 13.7045 8.57584 13.575 8.74333L13.5058 8.82167L12.3275 10L13.5058 11.1783C13.6569 11.328 13.745 11.5296 13.7522 11.7421C13.7594 11.9546 13.6852 12.1618 13.5446 12.3213C13.4041 12.4808 13.2078 12.5806 12.9961 12.6002C12.7844 12.6198 12.5733 12.5577 12.4058 12.4267L12.3275 12.3567L10.56 10.59C10.4164 10.4466 10.3301 10.2558 10.3172 10.0532C10.3043 9.8507 10.3657 9.65043 10.49 9.49L10.56 9.41083L12.3275 7.64333Z"
                fill="#09244B"
              />
            </g>
            <defs>
              <clipPath id="clip0_161_18073">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button>
      </div>

      <div className="top-nav">
        <nav className="sidebar-nav">
          {mainNav.map((item) => {
            const active = isItemActive(item.match);
            return (
              <Link
                key={item.label}
                to={item.path}
                className={`sidebar-nav-item ${active ? 'sidebar-nav-item--active' : ''}`}
              >
                <span
                  className={`sidebar-nav-icon ${active ? 'sidebar-nav-icon--active' : ''}`}
                >
                  {item.icon}
                </span>
                <span className="sidebar-nav-label">{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="sidebar-account">
          {isAccountOpen ? (
            <div className="sidebar-support">
              {supportNav.map((item) => {
                const active = item.path ? isItemActive([item.path]) : false;
                if (item.action === 'signout') {
                  return (
                    <button
                      key={item.label}
                      type="button"
                      onClick={handleSignOut}
                      className="sidebar-support-item sidebar-support-item--danger"
                    >
                      <span className="sidebar-support-icon">{item.icon}</span>
                      <span className="sidebar-support-label">{item.label}</span>
                    </button>
                  );
                }
                return (
                  <Link
                    key={item.label}
                    to={item.path || '/settings'}
                    className={`sidebar-support-item ${active ? 'sidebar-support-item--active' : ''}`}
                  >
                    <span className="sidebar-support-icon">{item.icon}</span>
                    <span className="sidebar-support-label">{item.label}</span>
                  </Link>
                );
              })}
            </div>
          ) : null}
          
          <button
            className={`sidebar-account-toggle ${isAccountOpen ? 'sidebar-account-toggle--open' : ''}`}
            type="button"
            aria-expanded={isAccountOpen}
            onClick={() => setIsAccountOpen((prev) => !prev)}
          >
            <div className="sidebar-account-left">
              <div className="sidebar-avatar">
                {currentUser?.avatar ? (
                  <img 
                    src={currentUser.avatar} 
                    alt={displayName}
                    className="w-full h-full object-cover rounded-full"
                  />
                ) : (
                  !loading && initials && (
                    <span className="text-sm font-medium text-white">{initials}</span>
                  )
                )}
              </div>
              <div className="sidebar-name">
                <p className="sidebar-user-name">{displayName}</p>
                <p className="sidebar-user-role">{displayRole}</p>
              </div>
            </div>
            <svg
              className="sidebar-account-icon"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
          </button>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
